/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Extracting_AudioInputs */



/**
* | output |
* | --- |
* | "Extracting audio from video..." |
*
* @param {Video_Extracting_AudioInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const video_extracting_audio = /** @type {((inputs?: Video_Extracting_AudioInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Extracting_AudioInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Audio wird aus Video extrahiert...")
	return /** @type {LocalizedString} */ ("Extracting audio from video...")
});